const googleKey = 'AIzaSyB7nDg4epGZ5rquKaLSKWplCfxETLEC_tw';
const mapboxKey = 'pk.eyJ1IjoibWRjaHJpc3RpZSIsImEiOiJjbDRscmtmMncwdDczM2NsaHNjN3EyNHVxIn0.JNCxKvvdb-oNIDNBYztmPA';
const recaptchaKey = '6LfA8YooAAAAADAu09vV0xYnIvClQrfQA3gfwNHR';
const stripeTestKey = 'pk_test_3SCEP4g67VwRNinmmJbAXS3I';
const stripeLiveKey = 'pk_live_4gb4QNyuJSu5hpU0BpLXP48n';

export {
    mapboxKey,
    googleKey,
    recaptchaKey,
    stripeTestKey,
    stripeLiveKey
}
